/*cd /home/ec2-user/docker/oficial/nodejs/FrGlobal/context/user
 head.append('Access-Control-Allow-Origin', '*')

        head.append('Cache-Control','no-cache, no-store, must-revalidate');
        head.append('Pragma',' no-cache');
        head.append('Expires','0');
docker restart front-doc-docente
*/

import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import funMsg from "global/utils/funMsg";
import funVar from "global/utils/funVar";
const headers = () => {
    let head = new Headers();
    head.append('Content-Type', 'application/json')
    head.append('Access-Control-Allow-Origin', '*')
    head.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    head.append('Pragma', ' no-cache');
    head.append('Expires', '0');
    head.append('mode', 'no-cors')
    const session = {
        email: localStorage.getItem('login_email'),
        token: localStorage.getItem('login_token'),
        tokenBrowser: localStorage.getItem('login_browser'),
        tokenTbkId: localStorage.getItem('login_tbkid'),
    }
    if (session.email && session.token) {
        //console.log("session.Header>>>>>>" ,session.token)
        head.append('email', session.email);
        head.append('x-token', session.token);
        head.append('system', funVar.getSystem());
    }
    if (session.tokenBrowser) {
        head.append('x-browser', session.tokenBrowser);
    }
    if (session.tokenTbkId) {
        head.append('x-tbkid', session.tokenTbkId);
    }
    let stPath = window.location.pathname
    head.append('front-path', stPath);
    //console.log("head ===========>",head)
    return head;
}
//https://www.saurabhmisra.dev/file-uploads-nodejs/
const reqUpLoadImg64 = async (stFileObj, path, dataInput) => {
    if (stFileObj === "") stFileObj = "attachment"
    let url = `${funVar.getUrlApi()}${path}`;
    const data = new FormData()
    //var dataFile = document.querySelector('#attachment');
    var dataFile = document.querySelector('#' + stFileObj);
    //console.log("EnviandoFile:", stFileObj, dataFile.files[0])
    const file = dataFile.files[0]
    const data64 = await toBase64(file)

    // console.log("getImg64", data64)
    // console.log("dataInput", JSON.stringify(dataInput))

    data.append('attachment', data64)
    data.append('datamsg', JSON.stringify(dataInput))
    //const options = {method:'POST',headers:headers()};
    //console.log("=========>" ,url,options)
    const session = {
        email: localStorage.getItem('login_email'),
        token: localStorage.getItem('login_token'),
        tokenBrowser: localStorage.getItem('login_browser'),
        tokenTbkId: localStorage.getItem('login_tbkid'),
    }

    const res = await axios.post(url, data, {
        headers: {
            Accept: 'application/json'
            , 'Content-Type': 'application/json'
            , 'x-token': session.token
            , 'x-browser': session.tokenBrowser
            , 'x-data': dataInput
        }
    })
    return res;
}
const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});
const reqUpLoadFile = async (stFileObj, path, dataInput) => {
    if (stFileObj === "") stFileObj = "attachment"
    let url = `${funVar.getUrlApi()}${path}`;
    const data = new FormData()
    //var dataFile = document.querySelector('#attachment');
    var dataFile = document.querySelector('#' + stFileObj);
    //console.log("EnviandoFile:",stFileObj,dataFile.files[0])
    const file = dataFile.files[0]
    data.append('attachment', dataFile.files[0])
    //console.log("dataInput",JSON.stringify(dataInput))
    data.append('datamsg', JSON.stringify(dataInput))
    //const options = {method:'POST',headers:headers()};
    //console.log("=========>" ,url,options)
    const session = {
        email: localStorage.getItem('login_email'),
        token: localStorage.getItem('login_token'),
        tokenBrowser: localStorage.getItem('login_browser'),
        tokenTbkId: localStorage.getItem('login_tbkid'),
    }

    const res = await axios.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
            , 'x-token': session.token
            , 'x-browser': session.tokenBrowser
            , 'x-data': dataInput
        }
    })
    return res;
}
const request = (form, method, path, body) => {
    // console.log("request ",method, path, body)
    if (path == null) {
        alert("No existe PATH definido en la API, (request)  :" + path + ": body : " + body)
        return new Promise((resolve, reject) => {
            return {
                ok: true, msg: "Error En Respuesta Servidor "
                    + "  <br/>\r\n" + "err"
                    + "  <br/>\n" + "url"
                    + "  <br/>\n" + "options"
            }
        })
    }

    let url = `${funVar.getUrlApi()}${path}`;
    if (path.startsWith("http://") || path.startsWith("https://")) url = path;
    else if (path.startsWith("/help")) url = `${funVar.getUrlHelp()}${path.substring(5)}`;
    else if (path.startsWith("/auth")) url = `${funVar.getUrlAuth()}${path.substring(5)}`;
    else if (path.startsWith("/admin")) url = `${funVar.getUrlAdmin()}${path.substring(6)}`;
    else if (path.startsWith("/admglb")) url = `${funVar.getUrlAdmGlb()}${path.substring(7)}`;
    else if (path.startsWith("/global")) url = `${funVar.getUrlAuth()}${path}`;
    else if (path.startsWith("$/")) url = `${funVar.getUrlAuth()}${path.substring(2)}`;
    // else if (path.startsWith("/$"))
    // 	 url = `${funVar.getUrlAuth()}${path.substring(2)}`;
    const options = { method, headers: headers() };
    // Las rutas /auth/* (signin, session-check, mf2-verify) necesitan mandar
    // y recibir la cookie SSO compartida entre apps del mismo dominio — sin
    // esto el navegador la ignora por default en un fetch cross-subdominio.
    if (path.startsWith("/auth")) options.credentials = 'include';
    body.param.system = funVar.getSystem()
    // Sólo tiene efecto real en el backend si la sesión es de la empresa 1 (ver
    // checkHeaders) — para cualquier otro usuario este valor se ignora ahí, así
    // que es seguro mandarlo siempre sin condicionar por app.
    const nroEmpresaSel = localStorage.getItem('nroEmpresaSel')
    if (nroEmpresaSel) body.param.nroEmpresaSel = nroEmpresaSel
        /*if (body)*/ options.body = JSON.stringify(body);

    return fetch(url, options)
        .then(async response => {
            //console.log("response.headers Fetch", form,response.headers, response)
            const token = response.headers.get("x-token")
            const xbrowser = response.headers.get("x-browser")
            const xtbkid = response.headers.get("x-tbkid")

            if (token && form.varToken != token) {
                localStorage.setItem('login_token', token)
                form.varToken = token
            }
            if (xbrowser && form.varXbrowser != xbrowser) {
                localStorage.setItem('login_browser', xbrowser)
                form.varXbrowser = xbrowser
            }
            if (xtbkid && form.varXtbkid != xtbkid) {
                //console.log("Camvbiando login_tbkid ******",form.varXtbkid, xtbkid)
                localStorage.setItem('login_tbkid', xtbkid)
                form.varXtbkid = xtbkid
            }
            //console.log(token,xbrowser,xtbkid)
            //console.log(form.varToken,form.varXbrowser,form.varXtbkid)
            if (token) {
                const decoded = jwtDecode(token);
                //console.log("token decoded",decoded)
                form.varUser.idUser = decoded._id
                form.varUser.nroEmp = decoded.nro_empresa
                form.setStateGlb()
            }
            const bodyResp = await response.json()
            // console.log("respuesta=>", bodyResp)





            //console.log("Request xbrowser==>",url,token,xbrowser)
            //console.log("bodyResp:", bodyResp)
            if (!bodyResp.ok) {
                //$("#primary-header-modal").modal('show');
                // En producción responseDataErr enmascara bodyResp.msg a un texto
                // genérico ("Error . Contacte a soporte."), así que buscar texto
                // como "Jwt Expirado" ahí nunca matchea ahí. bodyResp.reDirect NO
                // se enmascara y ya viaja "/auth/signin" para estos 3 casos
                // (Jwt Expirado / Jwt sin token / sesión vencida) — usarlo primero.
                if (bodyResp.reDirect === "/auth/signin"
                    || bodyResp.msg.includes("Jwt Expirado")
                    || bodyResp.msg.includes("Jwt Sin Token") ){
                    // Sesión vencida: no hay ninguna acción útil salvo volver a
                    // loguearse, así que se redirige directo en vez de mostrar un
                    // modal con botón "Login" — ese modal depende del JS de
                    // Bootstrap (jQuery .modal()), que varias apps de
                    // apps/empresa (framework CoreUI, ej. cl-emp-emidoc) nunca
                    // cargan; ahí el modal fallaba mudo (catch silencioso) y la
                    // pantalla quedaba en blanco para siempre.
                    // IP distinta a la del token: ese token no sirve más desde esta conexión; se descarta
                    // para que la pantalla de login no lo reuse.
                    if (bodyResp.error && bodyResp.error.name === 'HACKER_IP') localStorage.removeItem('login_token')
                    // Ya en /auth/...: no se redirige otra vez (evita el loop login -> error -> login).
                    if (!window.location.pathname.startsWith('/auth')) window.location.href = '/auth/signin';
                }
                else if (bodyResp.reDirect === "/admin/config/empresa/") {
                    // Esto NO es una sesión vencida: la empresa lisa y llanamente no
                    // tiene este módulo activo en seg_sist_emp. Reconectar (logout+login)
                    // no cambia ese dato — el login vuelve a calcular swEmpresa=false y
                    // cae en el mismo error de nuevo, así que redirigir a /auth/signin acá
                    // producía un loop infinito login -> error -> login. Solo se informa.
                    funMsg.msgFetchErr("La empresa no está activa para este módulo. Contacte a soporte.", "Empresa No Activa"
                        , [
                            { texto: "Aceptar", className: "btn btn-primary", onClick: () => $('#primary-header-modal').modal('hide') }
                        ])
                }
                else if (bodyResp.reDirect && bodyResp.reDirect.startsWith("http")) {
                    // El backend calculó a qué sistema (app) sí tiene acceso el
                    // perfil del usuario y mandó su URL de login en reDirect.
                    funMsg.msgFetchErr("Su perfil no tiene acceso a esta aplicación. Puede ingresar a la aplicación donde sí tiene acceso.", "Perfil No Autorizado"
                        , [
                            { texto: "Ir a mi Aplicación", className: "btn btn-success", onClick: () => { window.location.href = bodyResp.reDirect; } },
                            { texto: "Cancelar", className: "btn btn-secondary", onClick: () =>  $('#primary-header-modal').modal('hide') }
                        ])
                }
                else
                    funMsg.msgFetchErr(bodyResp.msg, "Error en Respuesta del Servidor")
                //alert("xxx" +bodyResp.msg)
                //window.location.replace('/auth/signin');
            }
            return bodyResp
        })
        .catch(err => {
            //console.log("Request Err==>", err)
            // funMsg.msgFetchErr hace (stMsg||"").split('\n') — pasarle el
            // Error tal cual (no un string) rompe el modal antes de mostrarse.
            funMsg.msgFetchErr((err && err.message) || String(err), "Error Sin Respuesta")
            return {
                ok: false, msg: "Error Catch En Respuesta Servidor "
                    + "  <br/>\r\n" + err
                    + "  <br/>\n" + url
                    + "  <br/>\n" + options
            };
        });
}
export {
    request,
    reqUpLoadFile,
    reqUpLoadImg64
}
